import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { AppBar, Toolbar, Button, makeStyles, Container, Drawer } from '@material-ui/core'
import logoImage from '../images/logo.jpg'
import MenuIcon from '@material-ui/icons/Menu'
import { useState } from 'react'

const useStyles = makeStyles(() => ({
    header: {
      backgroundColor: '#1F1A17',
      color: '#FFFFFF',
      paddingRight: '20px',
      paddingLeft: '20px',
      height: '67px',
      display: 'flex',
      justifyContent: 'center',
    },
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    menuButton: {
        fontFamily: 'Helvetica, sans-serif',
        size: '24px',
        marginLeft: '20px',
        marginRight: '20px',
        marginTop: '10px',
        marginBottom: '10px',
    },
    logoContainer: {
        width: '10%',
    },
    logo: {
        height: '67px',
        '@media (max-width: 960px)': {
          position: 'absolute',
          left: '0px',
          top: '-8px',
        }
    },
    menuIcon: {
      color: 'white',
      position: 'absolute',
      left: '40px',
      '@media (min-width: 960px)': {
        display: 'none',
        height: '80%',
      }
    },
    desktopLinks: {
      '@media (max-width: 960px)': {
        marginLeft: '4%',
        display: 'none',
      }
    },
    drawer: {
      width: '240px',
      display: 'flex',
      alignItems: 'center'
    }
  }))

export default function Header() {
    const { header, toolbar, logo, menuButton, logoContainer, menuIcon, desktopLinks, drawer } = useStyles()

    const [showDrawer, setShowDrawer] = useState(false);

    const headersData = [
        {
            label: 'Serviços',
            href: '/servicos'
        },
        {
            label: 'SGQ',
            href: '/sgq'
        },
        {
            label: 'Soluções',
            href: '/solucoes'
        },
        {
            label: 'Sobre nós',
            href: '/sobre'
        },
        {
            label: 'Contato',
            href: '/contato'
        }
    ]

    const getLogo = (
        <a href='/'>
          <img src={logoImage} alt='Fates' className={logo} />
        </a>
      )

    const getMenuButtons = () => {
        return headersData.map(({ label, href }) => {
          return (
            <Button
              {...{
                key: label,
                color: 'inherit',
                to: href,
                className: menuButton,
                component: RouterLink,
              }}
              onClick={() => {
                window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
              }}
            >
              {label}
            </Button>
          )
        })
      }

    // const toggleDrawer = (open) => {
    //     return headersData.map(({ label, href }) => {
    //       return (
    //             <Drawer
    //               open={open}
    //               onClose={toggleDrawer(false)}
    //             >
    //               {label}
    //             </Drawer>
    //       )
    //     })
    //   }

    return (
      <Container>
          <AppBar className={header}>
            <Toolbar className={toolbar}>
                <Container className={logoContainer}>
                    {getLogo}
                </Container>
                <Container className={desktopLinks}>
                    {getMenuButtons()}
                </Container>
                <Button onClick={() => {
                  window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
                  setShowDrawer(true);
                }}>
                  <MenuIcon className={menuIcon} fontSize="large" />
                </Button>
            </Toolbar>
        </AppBar>
          <Drawer
            anchor='right'
            className={drawer}
            open={showDrawer}
            onClose={() => setShowDrawer(false)}
          >
            {getMenuButtons()}
          </Drawer>
      </Container>
    )
}